/**
 * 仪表盘模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const instrumentPanel = {
  // 待办事项
  backlogPage(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/backlogPage`,params);
  },
  //仪表盘主机模块
  instance(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/instance`,params);
  },
  //仪表盘案例模块
  ticket(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/ticket`,params);
  },
  //主机和案例的柱状图
  histogram(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/histogram`,params);
  },
  //主机和案例则的折线图
  lineChart(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/lineChart`,params);
  },
  //RI节省
  getRiSaveCost(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/getRiSaveCost`,params);
  },
  //财务汇总
  getSumCost(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/getSumCost`,params);
  },
  //本月当前花费
  getCurrentCost(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/getCurrentCost`,params);
  },
  //本月预计费用
  getPredictCost(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/getPredictCost`,params);
  },
  //今年累计花费
  getCumulativeExpenditureYear(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/getCumulativeExpenditureYear`,params);
  },
  //账户余额
  getAccountBalance(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/getAccountBalance`,params);
  },
  //上次充值金额
  getLastRecharge(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/getLastRecharge`,params);
  },
  //财务柱状图
  financeHistogram(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/financeHistogram`,params);
  },
  //财务折线图
  financeLineChart(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/financeLineChart`,params);
  },
  //财务饼图
  financePieChart(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/financePieChart`,params);
  },
  //安全仪表盘
  securityDashboard(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/securityDashboard`,params);
  },
  //安全折线图
  securityLineChart(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/securityLineChart`,params);
  },
   //日志柱状图
  logHistogram(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/logHistogram`,params);
  },
  //日志折线图
  logLineChart(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/logLineChart`,params);
  },
  //网络访问拒绝
  networkAccessDeniedNum(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/networkAccessDeniedNum`,params);
  },
  //本月异常请求总数
  networkAccessExceptionNum(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/networkAccessExceptionNum`,params);
  },
  //资源删除
  deleteEventNum(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/deleteEventNum`,params);
  },
  //资源创建数量
  createEventNum(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/createEventNum`,params);
  },
  //获取Tag
  getTags(params) {
    return $http.post(`${global.API_URL}/sme/instrumentPanel/getTags?userName=${params.userName}&accountType=${params.accountType}`);
  }
}

export default instrumentPanel;



// WEBPACK FOOTER //
// ./src/api/instrumentPanel.js